// import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
// import DateFnsUtils from '@date-io/date-fns';
// import { ptBR } from "date-fns/locale";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const TextFieldDate = (props) => {
    const { value } = props;
    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    {...props}
                    format="DD/MM/YYYY"
                    value={dayjs(value).set("hour", 12)}
                // value={value}
                />
            </LocalizationProvider>
            {/* <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                <KeyboardDatePicker
                    variant="outlined"
                    format="dd/MM/yyyy"
                    margin="normal"
                    value={value ? value : null}
                    label={label}
                    onChange={onChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    {...props}
                />
            </MuiPickersUtilsProvider> */}
        </>
    );
}

export default TextFieldDate;